import "./Services.module.css";
import Naglowek from "@/reusable_sections/Header";
import NaszeUslugiSzczegoly from "./sections/NaszeUslugiSzczegoly";
import ZachetaDoKontaktu from "./sections/ZachetaDoKontaktu";
import Stopka from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Naglowek />
      <ZachetaDoKontaktu />
      <NaszeUslugiSzczegoly />
      <Stopka />
    </div>;
}